import koniBot from './bot/koni-bot';
import botBasicAction from "./bot/basic-actions";
import koniBotAction from './bot/koni-bot-action';
import synchronizeAction from './bot/synchronize-action';
import telegramAction from './deployment/telegram-action';
import telegramUser from './content-type/telegram-user';
import telegramGroup from './content-type/telegram-group';
import telegramBot from './content-type/telegram-bot';
import telegramLink from './content-type/telegram-link';
import telegramUserActivity from './content-type/telegram-user-activity';
import botMessageTemplate from './content-type/bot-message-template';
import telegramNotification from './content-type/telegram-notification';

export default {
  koniBot,
  botBasicAction,
  koniBotAction,
  telegramAction,
  synchronizeAction,
  'telegram-user': telegramUser,
  'telegram-group': telegramGroup,
  'telegram-bot': telegramBot,
  'telegram-link': telegramLink,
  'bot-message-template': botMessageTemplate,
  'telegram-notification': telegramNotification,
  'telegram-user-activity': telegramUserActivity,
};
